import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export const state = {
  currentWalletProvider: 'unknown',
  isWalletConnected: false,
  wallets: [],
  tokensAssetsProfile: {},
  tokensInfo: {},
  tokensWithBalance: {},
  tokensAvaliable: [],
  currentBestRate: {},
  getBestRateCount: 0,
  transactionHistory: [],
  unreadTxHistoryAmount: 0,
  unreadUserNotiAmount: 0,
  notiUnread: [],
  currentNetwork: 'disconnected',
  user: {},
  currentWeb3: undefined
}

const store = () => {
  return new Vuex.Store({
    state,
    actions,
    mutations,
    getters
  })
}

export default store



// WEBPACK FOOTER //
// ./src/store/index.js